import { Grid, Paper } from '@material-ui/core'
import { Fragment } from 'react'
import { AfterShowingStepProps } from '../AfterShowingStepper'
import AfterShowingForm from '../AfterShowingForm'

const AfterShowingSteps = ({
    currentStep,
    // apartment,
    classes,
    saveInstantRent,
    doStepBack,
    beforeLogin,
    isMobile
}: AfterShowingStepProps) => {
    return (
        <Fragment>
            <Grid item sm={12} md={12}>
                <Paper className={classes.formPaper}>
                    <AfterShowingForm
                        classes={classes}
                        saveInstantRentForm={saveInstantRent}
                        currentStep={currentStep}
                        doStepBack={doStepBack}
                        beforeLogin={beforeLogin}
                        isMobile={isMobile}
                    />
                </Paper>
            </Grid>
        </Fragment>
    )
}

export default AfterShowingSteps
